import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UntilDestroy } from '@ngneat/until-destroy';

export interface DataTestDialogState {
  $path: string;
}

@UntilDestroy()
@Injectable()
export class DataTestDialogStateService {
  private readonly state$$ = new BehaviorSubject<DataTestDialogState>({
    $path: '',
  });

  readonly path$: Observable<string> = this.state$$.pipe(map((x) => x.$path));

  getPath() {
    return this.state$$.value.$path;
  }

  setState(state: DataTestDialogState): void {
    this.state$$.next({ ...this.state$$.getValue(), ...state });
  }
}
